<template>
    <div class="ur-data-grid__edit__element ur-data-grid__edit__text-field" @mousedown="()=>{}">
        <input class="ur-data-grid__edit__element__input
                      ur-data-grid__edit__text-field__input"
               ref="input" :placeholder="placeholder" :tabindex="tabindex" :disabled="disabled"
               :value="currVal" @input="onInput"
               @mousedown="()=>{}"
               v-on="{...$listeners, input:()=>{}}"/>
    </div>
</template>

<script>
// TODO 1. key.enter to save?
export default {
    name: 'urDataGridEditTextField',
    props: {
        value      : [String,Number,Object,Array],
        placeholder: {type: String},
        disabled   : {type: Boolean, default: false},
        tabindex   : {type:[Number,String]},
    },
    data() { return {
        currVal: '', // value for "input" element
    }},
    watch: {
        value: {immediate: true, handler(val, w) {
			if (Array.isArray(val)) {
				if(val.length === 0) {
					this.currVal = '';
				}
				else {
					this.currVal = val[0];
				}
			}
			else {
				this.currVal = val; // when input comes
			}
        }},
    },
    methods: {
        onInput(e) {
            var v = e.target.value;
            this.currVal = v;
            this.$emit('input',v)
        },
        focus(opts) {
            this.$refs.input.focus(opts);
        },
        selectAll() {
            this.$refs.input.select();
        }
    },
};
</script>